import http from './http'

class Permissions {
  fetchByType (usetType) {
    return http.get(`/permissions/${usetType}`)
  }

  saveAvatar (payload) {
    return http.put(`/users/${payload.id}/avatar`, payload.data)
  }
}

export default new Permissions()



// WEBPACK FOOTER //
// ./src/services/permissions.js